import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const getAllActivityLogs = createAsyncThunk(
    "activityLog/getAllActivityLogs",
    async ({ skip, limit, audit_log_event, user_id }, { rejectWithValue }) => {
        try {

            const params = {
                ...(skip != null && { skip }),
                ...(limit != null && { limit }),
                ...(audit_log_event?.trim() && { audit_log_event }),
                ...(user_id?.trim() && { user_id }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/audit-logs`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getAllActivityLogsByUser = createAsyncThunk(
    "activityLog/getAllActivityLogsByUser",
    async ({ skip, limit, audit_log_event }, { rejectWithValue }) => {
        try {

            const params = {
                ...(skip != null && { skip }),
                ...(limit != null && { limit }),
                ...(audit_log_event?.trim() && { audit_log_event }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/audit-logs/by-user`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getAllActivityLogsByCertificate = createAsyncThunk(
    "activityLog/getAllActivityLogsByCertificate",
    async ({ skip, limit, certificate_id }, { rejectWithValue }) => {
        try {

            const params = {
                ...(skip != null && { skip }),
                ...(limit != null && { limit }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/audit-logs/by-certificate-id/${certificate_id}`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const downloadAllActivityLogs = createAsyncThunk(
    "activityLog/downloadAllActivityLogs",
    async ({ audit_log_event, user_id, username }, { rejectWithValue }) => {
        try {

            const params = {
                ...(audit_log_event?.trim() && { audit_log_event }),
                ...(user_id?.trim() && { user_id }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/audit-logs/csv`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            
            const parts = [audit_log_event, username].filter(Boolean);
            const fileName = parts.length > 0 ? parts.join('_') + '_audit_log' : 'audit_log';
            downloadBlob(response.data, `${fileName}.csv`);
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const downloadAllActivityLogsByCertificate = createAsyncThunk(
    "activityLog/downloadAllActivityLogsByCertificate",
    async ({ certificate_id, doc_ref }, { rejectWithValue }) => {
        try {

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/audit-logs/by-certificate-id/${certificate_id}`,
                {
                    ...axiosConfig,
                }
            );
            downloadBlob(response.data, `${doc_ref}.csv`);
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

const downloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
};